import {ChatMessage} from "@web-libs/features/chat/domain/types/chat-message.types";
import {UpsertChatMessage} from "@web-libs/features/chat/application/messenger/use-chat-messenger";

export const buildErrorHandler =
    (upsertChatMessage: UpsertChatMessage) =>
        async (sendRequest: () => Promise<void>, optimisticMessage: ChatMessage, chatroomId: string) => {
            try {
                await sendRequest();
            } catch (e) {
                const _errorMessage: ChatMessage = {
                    ...optimisticMessage,
                    deliveryStatus: "failed"
                }
                upsertChatMessage(chatroomId, _errorMessage);
                console.error(e)
            }
        }
